import React from "react";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import DealerChart from "~/components/Chart";
import PanelWrapper from "~/components/PanelWrapper";
import { getIndicatorName, getIndicatorValue } from "~/libs/getData";
import { useGetWorkSpaceQualityQuery } from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";
import { pickLocalized } from "~/shared/lib/pickLocalized";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { getIndicatorPeriod } from "~/libs/getFormatDate";
import s from "./BlockQualityNet.less";
import { NavLink } from "react-router-dom";

const BlockQualityNet = () => {
  const { t } = useTranslation();
  let language = localStorage.getItem("language");
  const currentDealerId = useCurrentDealerId();
  const { data, loading } = useGetWorkSpaceQualityQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "cache-and-network",
  });

  const getQualityForList = (IndicatorValue, isI503 = false) => {
    if (!!IndicatorValue) {
      const { doubleValue, Indicator } = IndicatorValue;
      const { Values = [] } = Indicator || {};
      return {
        name: getIndicatorName(Indicator),
        quarter: getIndicatorPeriod(
          isI503 ? (Values ? Values[0] : null) : IndicatorValue,
          "specQuarter"
        ),
        value: getIndicatorValue(Indicator, 2, null, doubleValue),
      };
    } else {
      return {
        quarter: "",
        value: DATA_STATUS_TYPES.DASH,
      };
    }
  };

  const indicator503 = get(
    data,
    "WorkSpaceGetter.getQuality.GlobalRatingVersion",
    {}
  );

  const i503 = getQualityForList(indicator503, true);

  let indicatorList = get(data, "WorkSpaceGetter.getQuality.indicators", []);

  const QualityValues = {
    i503: {
      ...i503,
      id: 503,
    },
    ...(indicatorList || []).reduce(
      (acc, { indicator, indicatorValue }) => ({
        ...acc,
        [`i${indicator.id}`]: {
          ...getQualityForList(indicatorValue),
          name: indicator.nameRu,
          id: indicator.id,
        },
      }),
      {}
    ),
  };

  const QualityListItem = ({ props }) => {
    const key = Object.keys(props);
    const indicator = props[key[0]];
    return (
      <NavLink className={s.clickable} to={"/gr/"}>
        <div>
          <span>
            {`${indicator.name} 
                          ${indicator.quarter}:`}
          </span>
          <span>
            {` ${
              indicator.value === DATA_STATUS_TYPES.DASH
                ? DATA_STATUS_TYPES.ND
                : indicator.value
            }`}
          </span>
        </div>
      </NavLink>
    );
  };

  const quarterForChart = get(indicator503, "dataForGraph") || [];

  const dealerQualitiesForChartLabels = quarterForChart.map(({ name, nameEn }) =>
    pickLocalized(name, nameEn, language === "en")
  );
  const dealerQualitiesForChartValues = quarterForChart.map(
    ({ IndicatorYearPercent }) => getIndicatorValue(IndicatorYearPercent, 0)
  );

  return (
    <PanelWrapper
      width={310}
      height={220}
      label={"Глобальный рейтинг"}
      customClassName={s.blockQualityNet}
      loading={loading}
    >
      <DealerChart
        values={dealerQualitiesForChartValues}
        labels={dealerQualitiesForChartLabels}
        type={"quality"}
      />
      {!loading && <QualityListItem props={QualityValues} />}
    </PanelWrapper>
  );
};

export default BlockQualityNet;
